/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Updated_ToastInputs */

const en_clients_updated_toast = /** @type {(inputs: Clients_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client updated.`)
};

const pt_br2_clients_updated_toast = /** @type {(inputs: Clients_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliente atualizado.`)
};

/**
* | output |
* | --- |
* | "Client updated." |
*
* @param {Clients_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_updated_toast = /** @type {((inputs?: Clients_Updated_ToastInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Updated_ToastInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_updated_toast(inputs)
	return pt_br2_clients_updated_toast(inputs)
});